import { render } from "./totalList.vue?vue&type=template&id=fee09cf2&scoped=true"
import script from "./totalList.vue?vue&type=script&lang=js"
export * from "./totalList.vue?vue&type=script&lang=js"

import "./totalList.vue?vue&type=style&index=0&id=fee09cf2&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fee09cf2"]])

export default __exports__